import { InvoiceViewSidebarWrapper } from '../../../../../externalInvoices/routes/InvoiceView/elements/InvoiceViewSidebar/styles'

export const RecurringInvoiceViewSidebarWrapper = InvoiceViewSidebarWrapper
